import { Type } from "@google/genai";

export const dailyReportCapability =  {
    name: 'daily_report',
    description: `function used the get user's stats about all the actions Multiplayer has taken on his behalf with an overview of his day.
    called whenever the user asks for a daily report, agenda, summary of his day, stats, what Multiplayer has done for him today, daily brief, etc.`,
};

export const sendEmailCapability =  {
    name: 'send_email',
    description: `function used whenever Multiplayer needs to send an email to one of the user's contacts.
    Always ask for confirmation before sending the email.`,
    parameters: {
      type: Type.OBJECT,
      properties: {
        subject: { type: Type.STRING },
        body: { type: Type.STRING, description: 'The body of the email in html format' },
        to: { type: Type.ARRAY, items: { type: Type.STRING } },
        cc: { type: Type.ARRAY, items: { type: Type.STRING } },
        bcc: { type: Type.ARRAY, items: { type: Type.STRING } },
      },
      required: ['subject', 'body', 'to'],
    },
};

export const checkAvailabilityCapability =  {
    name: 'check_availability',
      description:
        'Checks the availability of the user at a given time and date.',
      parameters: {
        type: Type.OBJECT,
        properties: {
          timeMin: {
            type: Type.STRING,
            description: `The minimum time to check the user's availability.
            Must be an RFC3339 timestamp with mandatory time zone offset, for example, 2011-06-03T10:00:00-07:00, 2011-06-03T10:00:00Z.`,
          },
          timeMax: {
            type: Type.STRING,
            description: `The maximum time to check the user's availability.
            Must be an RFC3339 timestamp with mandatory time zone offset, for example, 2011-06-03T10:00:00-07:00, 2011-06-03T10:00:00Z.`,
          },
        },
        required: ['timeMin', 'timeMax'],
      },
};